import { render, staticRenderFns } from "./TabbedPageLayout.vue?vue&type=template&id=13302169&"
import script from "./TabbedPageLayout.vue?vue&type=script&lang=js&"
export * from "./TabbedPageLayout.vue?vue&type=script&lang=js&"
import style0 from "./TabbedPageLayout.vue?vue&type=style&index=0&id=13302169&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports